import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import patientReducer from './slices/patientSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    patient: patientReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/login/fulfilled', 'auth/fetchUserData/fulfilled'],
      },
    }),
})
// typed version of redux store's state and dispactch function
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
